import { create } from 'zustand';
import { Operation, OperationFilter } from '@/types/operations';

interface OperationState {
  // Operations list and selected operation state
  operations: Operation[];
  selectedOperation: Operation | null;
  operationFilter: OperationFilter;
  
  // Loading and error states
  isLoading: boolean;
  error: string | null;
  
  // State setters
  setOperations: (operations: Operation[]) => void;
  setSelectedOperation: (operation: Operation | null) => void;
  setFilter: (filter: Partial<OperationFilter>) => void;
  resetFilter: () => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}

const initialFilter: OperationFilter = {
  status: 'active',
  search: '',
};

export const useOperationStore = create<OperationState>((set) => ({
  // Initial state
  operations: [],
  selectedOperation: null,
  operationFilter: initialFilter,
  isLoading: false,
  error: null,
  
  // State setters
  setOperations: (operations) => set({ operations }),
  setSelectedOperation: (operation) => set({ selectedOperation: operation }),
  setFilter: (filter) => set((state) => ({ 
    operationFilter: { ...state.operationFilter, ...filter } 
  })),
  resetFilter: () => set({ operationFilter: initialFilter }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));
